import { DateTime } from 'luxon'
import { useMemo } from 'react'
/**
 * useIsoToFormat
 * author: soojin.oh
 */

export const isoToFormat = (iso?: string, format?: string) => {
  if (!iso || !format) {
    return ''
  }

  const result = DateTime.fromISO(iso).setLocale('ko-KR').toFormat(format)
  // IE 의 경우 Intl 이 구버전이이서 한글 요일 변환이 안된다. 그래서 영문 요일을 한글로 replace 해주도록 한다
  return result
    .replace('Mon', '월')
    .replace('Tue', '화')
    .replace('Wed', '수')
    .replace('Thu', '목')
    .replace('Fri', '금')
    .replace('Sat', '토')
    .replace('Sun', '일')
}

// hook
const useIsoToFormat = function (iso?: string, format?: string) {
  return useMemo(() => isoToFormat(iso, format), [iso, format])
}

export default useIsoToFormat
